<template>
  <b-input-group>
    <b-input
      ref="autofocus"
      autocomplete="off"
      :type="show_password ? 'text' : 'password'"
      :disabled="disabled"
      :placeholder="placeholder"
      :value="value"
      @input="evOnInput"
      @change="evOnChange"
    />
    <template #append>
      <button
        variant="info"
        type="button"
        class="btn-show-password mt-0"
        :disabled="disabled"
        @click.stop="evOnTypeChange"
      >
        <b-icon :icon="show_password ? 'eye-slash' : 'eye'" />
      </button>
    </template>
  </b-input-group>
</template>

<script>
export default {
  name: "BInputPassword",
  props: {
    value: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: "Senha" },
  },
  data() {
    return {
      show_password: false,
    };
  },
  methods: {
    async evOnInput(value) {
      this.$emit("input", value);
    },

    async evOnChange(value) {
      this.$emit("change", value);
    },

    async evOnTypeChange() {
      this.show_password = !this.show_password;
      this.$emit("typechange", this.show_password);
    },

    async focus() {
      this.$refs.autofocus.focus();
    },
  },
};
</script>

<style>
</style>